import React from 'react';
import { Box } from '@firsttable/web-components/atoms';
import Footer from '../organisms/Footer';
import SEO from '../SEO';

interface LayoutProps {
  footer?: boolean;
  children?: any;
  footerComponent?: React.ReactNode | null;
}

/**
 * essential for any layout. Sets up the theme, children for the layout and the footer
 * @param children
 * @param footer
 * @param footerComponent
 * @constructor
 */
const ThemeLayout = ({ children, footer = true, footerComponent = null }: LayoutProps) => (
  <>
    <SEO />
    <Box flex="1 0 auto" minHeight="50vh" style={{ minHeight: '50dvh' }}>
      {children}
    </Box>
    {footer && !footerComponent && <Footer />}
    {footerComponent}
  </>
);
export default ThemeLayout;
